import { render, staticRenderFns } from "./BetaBanner.vue?vue&type=template&id=53711c3e&scoped=true"
import script from "./BetaBanner.vue?vue&type=script&lang=js"
export * from "./BetaBanner.vue?vue&type=script&lang=js"
import style0 from "./BetaBanner.vue?vue&type=style&index=0&id=53711c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53711c3e",
  null
  
)

export default component.exports